import { render } from "./SongsPanel.vue?vue&type=template&id=0535239e&scoped=true"
import script from "./SongsPanel.vue?vue&type=script&lang=js"
export * from "./SongsPanel.vue?vue&type=script&lang=js"

import "./SongsPanel.vue?vue&type=style&index=0&id=0535239e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0535239e"]])

export default __exports__